// REST API paths, grouped by the backend concept that owns them rather than by the service that
// happens to call them first - `/jobs/:jobId` is polled by several services, so it is its own
// group. A new REST service adds a group here instead of inlining path literals at the call site.
//
// Collection paths stay spelled out in full so they remain greppable against rest-api's routes,
// the OpenAPI spec and the MSW handlers. Only item paths are derived, from the collection constant
// they extend, so a renamed resource cannot leave the collection and the item path out of step.

export const partnerPreviewEndpoints = {
	participations: '/software/partner-preview-participations',
	enrollments: '/software/partner-preview-enrollments',
	enrollment: (enrollmentId) => {
		return `${partnerPreviewEndpoints.enrollments}/${enrollmentId}`;
	},
	accessRequest: '/software/partner-preview-access-request',
};

// Banner dismissals are not a Partner Preview concept - any banner in the hub can be dismissed
// through this one endpoint, keyed by bannerKey (see BannerDismissalService).
export const bannerDismissalEndpoints = {
	bannerDismissals: '/software/banner-dismissals',
};

// Users are an IAM concept, not a Partner Preview one, so they get their own group.
export const iamEndpoints = {
	users: '/iam/users',
};

export const jobEndpoints = {
	job: (jobId) => {
		return `/jobs/${jobId}`;
	},
};

// Licensing: the Community keys a company generates to activate its machines (SYN-3463). The
// products batch read predates this group and still spells its path inline in LicensingService.
export const licensingEndpoints = {
	communityKeys: '/v1/licensing/community-keys',
};
